import { Button, Tooltip } from '@treezor/design-system';

import { useTranslation } from 'react-i18next';

import { useAddWallet } from '../../hooks';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useAppDispatch } from '@/hooks/redux-helpers';

import { IUser } from '@/features/user/store/user.model';

import { openModal } from '@/store/actions/core.actions';

import { featuresSlugs } from '@/features/roles/store/models/features.model';

import { IAddWalletModalProps } from './AddWalletModal';

interface IAddWalletProps {
  user: IUser;
}

export const AddWallet = ({ user }: IAddWalletProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { hasAccessToFeature } = useAccesControl();
  const { shouldDisabledAddWallet, canAddWallet } = useAddWallet(user);

  const toggleAddWalletDialog = () =>
    dispatch(openModal<IAddWalletModalProps>('addWalletModal', { user }, { maxWidth: 'lg' }));

  if (!hasAccessToFeature(featuresSlugs.ADD_WALLET)) {
    return null;
  }

  return (
    <>
      {shouldDisabledAddWallet || !canAddWallet ? (
        <Tooltip
          placement="bottom"
          messageContent={
            shouldDisabledAddWallet
              ? t('pages.currentProfiles.actionUser.addWallet.statusDisabled')
              : t('pages.currentProfiles.actionUser.addWallet.countryDisabled')
          }
          contentClassName="min-w-[180px]"
        >
          <Button id="add-wallet-dialog-btn" testId="add-wallet" icon="add" size="s" variant="secondary" disabled>
            {t('pages.currentProfiles.actionUser.addWallet.add')}
          </Button>
        </Tooltip>
      ) : (
        <Button
          testId="add-wallet"
          id="add-wallet-dialog-btn"
          icon="add"
          variant="secondary"
          size="s"
          onClick={toggleAddWalletDialog}
        >
          {t('pages.currentProfiles.actionUser.addWallet.add')}
        </Button>
      )}
    </>
  );
};
